var map = {
	"./MockupEspanhol.png": 73002,
	"./MockupIngles.png": 38600,
	"./MockupItaliano.png": 67803,
	"./MockupPortugues.png": 81272,
	"./QRcode.jpeg": 12993,
	"./about-section.jpg": 92060,
	"./alert-chat-icon.svg": 52412,
	"./alert-phone-icon.svg": 70952,
	"./appstore_badge.svg": 99536,
	"./asset-mackup-big.png": 42047,
	"./asset-mackup.png": 28758,
	"./asset-mackup@2x.png": 93301,
	"./asset-mackup@3x.png": 87566,
	"./babylon-icon-cta.png": 31327,
	"./backpack.jpg": 63401,
	"./benefitsCheck.png": 88729,
	"./business.jpg": 7592,
	"./card-icon.svg": 31655,
	"./cashback-icon.svg": 71769,
	"./chat-alert-blue.svg": 93634,
	"./digital-sub-icon.svg": 52340,
	"./ecobag.jpg": 98954,
	"./economy-icon.svg": 69554,
	"./graph-icon.svg": 4326,
	"./icon-craftedforyou.svg": 1812,
	"./icon-ellipsis-v.svg": 81872,
	"./icon-gorgeous.svg": 78477,
	"./icon-moderndesign.svg": 72884,
	"./icon-responsivelayout.svg": 60640,
	"./icon-welldocumented.svg": 82743,
	"./laptop.jpg": 62537,
	"./money-header-icon.svg": 6930,
	"./money-icon.svg": 37759,
	"./phone-copy-blue.svg": 17462,
	"./phone-icon.svg": 23136,
	"./places-icon.svg": 41580,
	"./prev-icon.svg": 56567,
	"./renegotiation-icon.svg": 9196,
	"./shape.svg": 88103,
	"./svg/facebook-logo": 64775,
	"./svg/facebook-logo.js": 64775,
	"./svg/telegram-logo": 22860,
	"./svg/telegram-logo.js": 22860,
	"./svg/whatsapp-logo": 59046,
	"./svg/whatsapp-logo.js": 59046,
	"./telegram-qrcode.png": 26797,
	"./transfer-icon.svg": 74823,
	"./whatsapp-qrcode.png": 16652,
	"./work-with-us.png": 3691,
	"./wtts-blue.svg": 17944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80610;